import React, { useState, useEffect } from "react";
import LayoutNew from "../../common/LayoutNew";
export const TrangChu = () => {
    document.title = "Hệ thống đại lý";
    useEffect(() => {
    }, []);




    return (
        <LayoutNew>
            <div></div>
        </LayoutNew>
    );
};
